(function () {
    'use strict';

    angular
        .module('elogbooks.common.files')
        .controller('SendToMeridianForm', SendToMeridianForm);

    SendToMeridianForm.$inject = [
        '$uibModalInstance',
        '$state',
        'apiClient',
        'messenger',
        'fileResponse',
        'meridianDocTypes',
        'integrationsService',
        'moment',
        '$scope'
    ];

    function SendToMeridianForm(
        $uibModalInstance,
        $state,
        apiClient,
        messenger,
        fileResponse,
        meridianDocTypes,
        integrationsService,
        moment,
        $scope
    ) {
        var vm = this;

        vm.meridianDocTypes = meridianDocTypes;
        vm.selectedDocType = null;
        vm.selectedDocType2 = null;
        vm.buttonDisabled = false;

        // Initialize elogbooks-select models for static data
        vm.meridianDocCatModel = {
            staticData: vm.meridianDocTypes,
            selected: null,
            required: true,
            disabled: false,
            onSelect: function() {
                // Update second dropdown with selected category data
                vm.meridianDocTypeModel.staticData = vm.meridianDocCatModel.selected ?
                    vm.meridianDocTypes[vm.meridianDocCatModel.selected.href] : null;
                vm.meridianDocTypeModel.selected = null;
                vm.selectedDocType = vm.meridianDocCatModel.selected ? vm.meridianDocCatModel.selected.href : null;
            },
            onRemove: function() {
                vm.meridianDocTypeModel.staticData = null;
                vm.meridianDocTypeModel.selected = null;
                vm.selectedDocType = null;
                vm.selectedDocType2 = null;
            }
        };

        vm.meridianDocTypeModel = {
            staticData: null,
            selected: null,
            required: true,
            disabled: false,
            onSelect: function() {
                if (vm.meridianDocTypeModel.selected) {
                    vm.selectedDocType2 = vm.meridianDocTypeModel.selected.href;
                }
            },
            onRemove: function() {
                vm.selectedDocType2 = null;
            }
        };

        var integration = {
            docTypes: meridianDocTypes
        };

        integrationsService.addMeridianDefaultDocTypes(integration, fileResponse);

        if (integration.defaultDocType) {
            vm.selectedDocType = integration.defaultDocType;
            vm.selectedDocType2 = integration.defaultDocType2;

            // Set default values for elogbooks-select models
            vm.meridianDocCatModel.selected = { href: integration.defaultDocType, value: integration.defaultDocType };
            vm.meridianDocTypeModel.staticData = vm.meridianDocTypes[integration.defaultDocType];
            if (integration.defaultDocType2 && vm.meridianDocTypeModel.staticData) {
                vm.meridianDocTypeModel.selected = {
                    href: integration.defaultDocType2,
                    value: vm.meridianDocTypeModel.staticData[integration.defaultDocType2] || integration.defaultDocType2
                };
            }
        }

        vm.cancel = () => $uibModalInstance.dismiss('cancel');

        vm.submit = vm.create = () => {
            apiClient.create(fileResponse.getLink('create-integration'), {
                documentDate: moment.utc(fileResponse.documentDate).format('YYYY-MM-DDT00:00:00+00:00'),
                integration: {meridian: vm.selectedDocType2},
                _links: {file: {href: fileResponse.getLink('self')}}
            }).then((response) => {
                if (response) {
                    $uibModalInstance.close(response);

                    $state.go('.', {}, {reload: $state.get('^.^')}).then(function () {
                        messenger.success('FILE_SEND_TO_MERIDIAN_SUCCESS');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                    $uibModalInstance.close(false);
                }
            });
        };
    }
})();
